import axios from "axios"
import store from "../redux/store";
import { changeSessionModal } from "../reduxSlice/sessionExpire/sessionExpireSlice";
import { getApiBaseUrl } from "./api";

export type ApiRequestType = "get" | "post" | "put" | "delete";

interface APIType {
    api: string;
    method: ApiRequestType;
    baseurl?: string;
    body?: any;
    isAuthentic?: boolean;
    extraParams?: any;
    isBearer?: boolean;
    header?: any;
}

const axiosClient = axios.create({});

// Add request interceptor for auth
axiosClient.interceptors.request.use(
    async (config) => {
        // Check for browser environment
        const auth = localStorage.getItem('userLoginData') ? JSON.parse(localStorage.getItem('userLoginData') as string) : null;
        const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token') as string) : null;
        config.headers.Authorization = (auth?.token !== undefined) ? `Bearer ${auth?.token}` : `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
    (response): any => response,
    (error) => {
        if (error.response.status === 401 || error.response.data.message === 'jwt expired') {
            store.dispatch(changeSessionModal(true));
            localStorage.clear();
            // window.location.href = '/login'
            return
        }
        return Promise.reject(error);
    }
);

export default axiosClient;